import { Modal, Button } from 'react-bootstrap';
import { useErrorModalStore } from '@infrastructure/api/store/errorModalStore';

export default function SystemErrorModal() {
  const { systemError, dismiss } = useErrorModalStore();

  return (
    <Modal show={systemError !== null} onHide={dismiss} centered>
      <Modal.Header
        closeButton
        style={{ backgroundColor: '#f8d7da', borderBottom: '1px solid #dc3545' }}
      >
        <Modal.Title style={{ color: '#721c24' }}>
          Oops, Something Went Wrong
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{systemError}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={dismiss}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
